(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wuftrek-product-color-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wuftrek-product-color-swatches')) {
  customElements.define(
    'wuftrek-product-color-swatches',
    class WuftrekProductColorSwatches extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info') || document;
        this.links = Array.from(this.querySelectorAll('[data-wt-color-link]'));
        this.onVariantChange = this.updateLinks.bind(this);
        this.scope.addEventListener('change', this.onVariantChange);
        this.updateLinks();
      }

      disconnectedCallback() {
        if (this.scope && this.onVariantChange) {
          this.scope.removeEventListener('change', this.onVariantChange);
        }
      }

      slug(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      selectedPrimary() {
        const picker = this.scope.querySelector('variant-selects[data-primary]');
        if (picker) {
          const firstGroup = picker.querySelector('.product-form__input');
          if (firstGroup) {
            const radio = firstGroup.querySelector('input[type="radio"]:checked');
            if (radio && radio.value) return radio.value;

            const select = firstGroup.querySelector('select');
            if (select && select.value) return select.value;
          }
        }

        return this.dataset.currentPrimary || '';
      }

      parseVariantMap(value) {
        return String(value || '')
          .split('|')
          .filter(Boolean)
          .reduce((map, pair) => {
            const separator = pair.indexOf(':');
            if (separator === -1) return map;
            map[pair.slice(0, separator)] = pair.slice(separator + 1);
            return map;
          }, {});
      }

      updateLinks() {
        const primary = this.slug(this.selectedPrimary());

        this.links.forEach((link) => {
          const variants = this.parseVariantMap(link.dataset.variants);
          const variantId = variants[primary];
          link.href = variantId
            ? link.dataset.baseUrl + '?variant=' + encodeURIComponent(variantId)
            : link.dataset.baseUrl;
        });
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

})();
